export default __webpack_public_path__ + "static/media/logo-ae-junior-couture.af6fdea6.svg";